//var doc = new jsPDF('p', 'pt', 'a4');
//var specialElementHandlers = {
//
//};
//
//$('#print').click(function () {
//
//	doc.fromHTML($('#formation').get(0), 15, 15, {
//		'width': 250,
//		'margin': 1.5,
//		'pagesplit': true,
//		'elementHandlers': specialElementHandlers
//	});
//
//	doc.save('sample-file.pdf');
//});